// extracted by mini-css-extract-plugin
export default {"card-width":"MetricsCards-module__card-width__XeqON","cardWidth":"MetricsCards-module__card-width__XeqON"};